// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from "../pages/Home/Home";
const __wvcRoutePaths = ["/", "/HomePage", "/startseite"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["aboutmepage", "coursesseminarspage", "energyflowyogapage", "homepage", "impressum", "imprintpage", "kurse-seminare", "ourstudiopage", "post", "qi-gong-yoga", "qi-gong-yoga2", "qigongandyogapage", "qigongyogapage", "startseite", "training-im-einklang", "traininginharmonypage", "uber-mich", "unser-studio", "was-ist-tai-chi", "whatistaichipage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      <Route path={__wvcRoutePaths[0]} element={<HomePage />} />
      <Route path={__wvcRoutePaths[1]} element={<HomePage />} />
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[2]} element={<HomePage />} />
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
